/*
 * aiClerk（AI 填表员）后端直连配置 —— XheyClaw 后端各环境域名的【唯一真相源】。
 *
 * 原来走同源代理（/xhey-ai → Vite dev proxy / 生产 nginx），现改为直连各环境后端域名。
 * 按编译期注入的 __BUILD_ENV__（local/test/staging/prod）选域名，改后端只改这里。
 *
 * 直连后的几个前提（已在别处满足，勿回退）：
 *   - 鉴权走 Authorization: Bearer（auth/tokenService），跨域可用，不依赖同源 cookie
 *   - chat SSE 后端直吐 OpenAI delta 格式，hooks/useSSEChat 内置 OpenAITransformer 兜底
 *   - 需后端对前端 origin 放行 CORS（Allow-Origin + Allow-Credentials + 允许
 *     Authorization / x-group-id / x-team-id / x-conversation-id / x-app-id 等头）
 */

// 各环境 XheyClaw 后端域名。local 直连 test，便于本地联调、与线上行为一致。
const XHEY_CLAW_HOST_BY_ENV: Record<string, string> = {
  local: 'https://xheyclawapi-test.5181688.com',
  test: 'https://xheyclawapi-test.5181688.com',
  staging: 'https://xheyclawapi-staging.5181688.com',
  prod: 'https://xheyclawapi.5181688.com'
}

/** 当前环境的 XheyClaw 后端域名（未知环境回落 test）。 */
export const XHEY_AI_HOST =
  XHEY_CLAW_HOST_BY_ENV[__BUILD_ENV__] || XHEY_CLAW_HOST_BY_ENV.test

/**
 * aiClerk 所有后端请求的 base（含 /api 前缀）。
 * 原代理链路 /xhey-ai/<x> 会被 rewrite 成 /api/<x>，直连后等价于 <host>/api/<x>。
 */
export const XHEY_AI_BASE = `${XHEY_AI_HOST}/api`
